export default "__VITE_ASSET__DILip0mw__"